import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'

import IconLink from 'components/Shared/IconLink/Index'

const ClearFiltersLink = ({ clearUrl }) => {
  const { t } = useTranslation()

  return (
    <Link to={clearUrl}>
      <IconLink
        iconName='icon-clear'
        text={t('ticketsPage.clearFiltersLink')}
      />
    </Link>
  )
}

ClearFiltersLink.propTypes = {
  clearUrl: PropTypes.string.isRequired,
}

export default ClearFiltersLink
